import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hooks/usetoast";
import { queryClient } from "../../../config";
import DataService from '../../../config/DataServices'

const { getRequest, postRequest , putRequest , deleteRequest } = DataService()


export const useFaqList = ({ page, size, searchText, sortOrder, sortField }) => {

    return useQuery({
        queryKey: ["faq-list", page, size,searchText,sortOrder,sortField],
        queryFn: () => {
            return getRequest(`/faqs?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`)
        }
    })
}

export const useAddfaq = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/faqs", { ...data })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data.message)
            }
            queryClient.refetchQueries("faq-list");
            return toast.success(success?.data?.message)
        }
    })
}

export const useUpdatefaq = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return putRequest(`/faqs/${data.id}`, {question:data.question,answer:data.answer})
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("faq-list");
            return toast.success(success?.data?.message)
        }
    })
}

export const useGetSingleFaq = (id) => {

    return useQuery({
        queryFn: () => {
            return getRequest(`/faqs/${id}`)
        },
    })
}


export const useUpdateStatus = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: ({ question, answer, isActive, _id }) => {
            return putRequest(`/faqs/${_id}`, { question, answer, isActive })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("faq-list");
            return toast.success(success?.data?.message)
        }
    })
}

export const useDeletefaq = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return deleteRequest(`/faqs/${data._id}`)
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("faq-list");
            return toast.success(success?.data?.message)
        }
    })
}